<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FTfhXg/tc-custom/9781497670495.jpg?1701351340447" alt="This image is the cover for the book Organ Grinder's Monkey, The Allerton Avenue Precinct Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Organ Grinder's Monkey, The Allerton Avenue Precinct Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>Lowenkopf and Greeley are called in on a gruesome murder in a psychiatric facility in the Bronx, where the victim has had an internal organ removed and damaged, like other victims of the same killer. Lowenkopf goes undercover in the hospital and learns that a patient in a locked ward is taking credit for the crimes, sending out his spirit to avenge an old injury from a past life. Unwilling to believe his incredible story, but confronted with details only the killer should know, Lowenkopf and Greeley investigate the people around the boasting patient—his doctor, a social worker, and the staff of the hospital. But none of the candidates could possibly have committed the crimes, and Lowenkopf must solve a locked-room puzzle with a madman insisting on his guilt. <br/><br/> The Organ Grinder’s Monkey <i>is the 3rd book in the Allerton Avenue Precinct Novels, but you may enjoy reading the series in any order.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Fliegel
      </h2>
      
      <p class="authorDescription body article">Richard Fliegel is a writer and associate dean at USC Dornsife College. He has published several detective novels and short stories in collections. His book&#160;<I>A Minyan for the Dead</I>&#160;was nominated for a Shamus Award by the Private Eye Writers of America. A member of the WGA West, he has written for&#160;<I>Star Trek</I>&#160;and ABC network television. He lives in California with his wife, Lois; his dog, Cleo; and occasionally, with his sons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Premier Digital Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d41b361